import React, { useState } from 'react';
import { X, Search, Languages, Check } from 'lucide-react';
import './LanguageSelector.css';
import { INDIAN_LANGUAGES } from '../../../constants/constants';

const LanguageSelector = ({ 
  isOpen, 
  onClose, 
  onSelect, 
  selectedLanguageId = null,
  title = "Select Language for India"
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Languages in India with Malayalam, Hindi, Tamil at top
  const indianLanguages = INDIAN_LANGUAGES;

  const filteredLanguages = searchTerm 
    ? indianLanguages.filter(language =>
        language.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        language.nativeName.includes(searchTerm)
      )
    : indianLanguages;

  const handleLanguageSelect = (language) => {
    onSelect(language);
    onClose();
  };

  const handleClose = () => {
    setSearchTerm('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="language-selector-overlay">
      <div className="language-selector-dialog">
        <div className="language-selector-header">
          <h2>{title}</h2>
          <button className="language-selector-close" onClick={handleClose}>
            <X size={20} />
          </button>
        </div>

        <div className="language-selector-content">
          <div className="language-search-container">
            <div className="language-search-input-container">
              <Search size={16} className="language-search-icon" />
              <input
                type="text"
                placeholder="Search languages..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="language-search-input"
                autoFocus
              />
            </div>
          </div>

          <div className="languages-list">
            {filteredLanguages.length > 0 ? (
              filteredLanguages.map(language => (
                <div 
                  key={language.id} 
                  className={`language-item ${selectedLanguageId === language.id ? 'selected' : ''}`}
                  onClick={() => handleLanguageSelect(language)}
                >
                  <div className="language-info">
                    <div className="language-name">{language.name}</div>
                    <div className="language-native">{language.nativeName}</div>
                  </div>
                  {selectedLanguageId === language.id && (
                    <Check size={16} className="language-check" />
                  )}
                </div>
              ))
            ) : (
              <div className="no-results">
                <Languages size={32} />
                <p>No languages found</p>
                <span>Try a different search term</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
